import { ImpactPartnerInfo } from '@platform/client/schemas';
import { getGainAccessItems } from './partnerLandingContent';

type PartnerLandingGainAccessSectionProps = {
  partner: ImpactPartnerInfo;
};

export const PartnerLandingGainAccessSection = ({
  partner,
}: PartnerLandingGainAccessSectionProps) => {
  const items = getGainAccessItems(partner);

  return (
    <section className='bg-secondary-brand-25 px-4 py-16 sm:px-8 sm:py-20'>
      <div className='mx-auto max-w-[800px]'>
        <h2 className='mb-12 text-center text-display-md font-medium text-gray-600 sm:mb-16'>
          What You&apos;ll Gain Access To
        </h2>
        <div className='flex flex-col gap-8 sm:gap-10'>
          {items.map((item) => (
            <div
              key={item.title}
              className='flex flex-col items-center gap-4 text-center sm:flex-row sm:items-start sm:gap-5 sm:text-left'
            >
              <div className='flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-brand-500'>
                <img src={item.iconSrc} alt="" width={28} height={28} className="object-contain" />
              </div>
              <div className='min-w-0 max-w-[660px]'>
                <h3 className='text-display-xs font-medium text-gray-600'>{item.title}</h3>
                <p className='mt-2 text-lg font-normal leading-7 text-gray-500'>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
